/** shadcn/ui Label (plain-element flavor; was .my-label). */
import * as React from 'react';
import { cn } from '../../lib/utils';

const Label = React.forwardRef<HTMLLabelElement, React.LabelHTMLAttributes<HTMLLabelElement>>(
  ({ className, ...props }, ref) => (
    <label
      ref={ref}
      className={cn('mb-1.5 block text-sm font-medium text-foreground', className)}
      {...props}
    />
  ),
);
Label.displayName = 'Label';

export { Label };
